import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolders: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolders"><Path d="M2.5 7.5V20.5H17.5V9.5H10L8 7.5H2.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M17.5 16.5H21.5V5.5H14L12 3.5H6.5V7.5" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFolders;
